import React from 'react'
import QuotesSVG from 'app/components/SVGS/Quotes'

const FavoriteActivityContent = ({ quoteText }) => (
  <div className="favorite-activity-content">
    <QuotesSVG />
    <div className="favorite-activity-content__text">{quoteText}</div>
  </div>
)

FavoriteActivityContent.displayName = 'FavoriteActivityContent'

export default FavoriteActivityContent
